{
  "familyId": "GET-BREUK-RASTER",
  "questions": [
    {
      "id": "GET-BREUK-RASTER-001",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer $\\frac{3}{8}$ van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 4,
          "targetCount": 3,
          "mode": "shade_count",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk en rooster",
            "content": "De noemer (8) vertelt hoeveel vakjes er totaal zijn. De teller (3) vertelt hoeveel vakjes je moet arceren. Tel het totaal: 2 × 4 = 8 vakjes. Arceer er 3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_shade_count_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Het rooster heeft 2 rijen × 4 kolommen = 8 vakjes. De breuk $\\frac{3}{8}$ betekent: arceer 3 van de 8 vakjes.",
        "solutionSteps": [
          "Tel het totaal aantal vakjes: 2 × 4 = 8",
          "De teller is 3 → arceer 3 vakjes",
          "Het maakt niet uit welke 3 vakjes je kiest"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-BREUK-RASTER-002",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer de helft van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 3,
          "targetCount": 3,
          "mode": "shade_count",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De helft",
            "content": "De helft = $\\frac{1}{2}$. Tel het totaal: 2 × 3 = 6 vakjes. De helft van 6 = 3. Arceer 3 vakjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_shade_helft",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Het rooster heeft 6 vakjes. De helft van 6 = 3. Arceer dus 3 van de 6 vakjes.",
        "solutionSteps": [
          "Tel het totaal: 2 × 3 = 6 vakjes",
          "De helft van 6 = 3",
          "Arceer 3 vakjes"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-BREUK-RASTER-003",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Er zijn al 2 vakjes gearceerd. Arceer er meer zodat in totaal $\\frac{5}{10}$ gearceerd is.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 5,
          "targetCount": 5,
          "mode": "shade_count",
          "preShaded": [0, 1],
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aanvullen tot een breuk",
            "content": "Er zijn 10 vakjes totaal. Je moet $\\frac{5}{10}$ arceren, dus 5 vakjes. Er zijn al 2 gearceerd, dus je moet er nog 3 bijkleuren.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_aanvullen",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het rooster heeft 2 × 5 = 10 vakjes. $\\frac{5}{10}$ = 5 vakjes arceren. Er zijn al 2 gearceerd, dus je moet er nog 3 bij arceren.",
        "solutionSteps": [
          "Totaal: 2 × 5 = 10 vakjes",
          "$\\frac{5}{10}$ → 5 vakjes moeten gearceerd zijn",
          "Er zijn al 2 gearceerd → nog 3 erbij"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-BREUK-RASTER-004",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer $\\frac{3}{4}$ van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 3,
          "gridCols": 4,
          "targetCount": 9,
          "mode": "shade_fraction",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "3 van de 4 delen",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk van een rooster",
            "content": "Het rooster heeft 3 × 4 = 12 vakjes. $\\frac{3}{4}$ van 12 = 12 ÷ 4 × 3 = 9 vakjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_shade_fraction",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het rooster heeft 3 × 4 = 12 vakjes. $\\frac{3}{4}$ van 12: deel door 4 → 3, keer 3 → 9. Arceer 9 vakjes.",
        "solutionSteps": [
          "Totaal: 3 × 4 = 12 vakjes",
          "12 ÷ 4 = 3 (één kwart)",
          "3 × 3 = 9 (drie kwart)",
          "Arceer 9 vakjes"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-BREUK-RASTER-005",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer 25% van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 4,
          "gridCols": 4,
          "targetCount": 4,
          "mode": "shade_count",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "percentageBar",
          "showWhen": "wrong",
          "data": {
            "percentage": 25,
            "label": "25% = een kwart"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Procent naar aantal",
            "content": "25% = $\\frac{25}{100}$ = $\\frac{1}{4}$. Het rooster heeft 4 × 4 = 16 vakjes. $\\frac{1}{4}$ van 16 = 4 vakjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_procent",
      "variantIndex": 1,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "25% = $\\frac{1}{4}$. Het rooster heeft 4 × 4 = 16 vakjes. Een kwart van 16 = 4. Arceer 4 vakjes.",
        "solutionSteps": [
          "25% = $\\frac{1}{4}$",
          "Totaal: 4 × 4 = 16 vakjes",
          "$\\frac{1}{4}$ van 16 = 4",
          "Arceer 4 vakjes"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-BREUK-RASTER-006",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer $\\frac{2}{6}$ van het rooster. (Dat is hetzelfde als $\\frac{1}{3}$.)",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 3,
          "targetCount": 2,
          "mode": "shade_count",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 6,
            "label": "2/6 = 1/3",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijkwaardige breuken",
            "content": "$\\frac{2}{6}$ en $\\frac{1}{3}$ zijn gelijk: deel teller en noemer door 2. Het rooster heeft 2 × 3 = 6 vakjes — arceer er 2.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_equivalent",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het rooster heeft 2 × 3 = 6 vakjes. $\\frac{2}{6}$ betekent 2 van de 6 arceren. Dat is hetzelfde als $\\frac{1}{3}$ (deel teller en noemer door 2).",
        "solutionSteps": [
          "Tel het totaal: 2 × 3 = 6 vakjes",
          "Teller is 2 → arceer 2 vakjes",
          "Check: $\\frac{2}{6}$ = $\\frac{1}{3}$ ✓"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-BREUK-RASTER-007",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer 50% van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 4,
          "gridCols": 4,
          "targetCount": 8,
          "mode": "shade_count",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "percentageBar",
          "showWhen": "wrong",
          "data": {
            "percentage": 50,
            "label": "50% = de helft"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Procent en helft",
            "content": "50% = $\\frac{1}{2}$. Het rooster heeft 4 × 4 = 16 vakjes. De helft van 16 = 8. Arceer 8 vakjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_procent_helft",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "50% is de helft. Het rooster heeft 4 × 4 = 16 vakjes. De helft van 16 = 8. Arceer dus 8 vakjes.",
        "solutionSteps": [
          "50% = $\\frac{1}{2}$",
          "Totaal: 4 × 4 = 16 vakjes",
          "De helft van 16 = 8",
          "Arceer 8 vakjes"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-BREUK-RASTER-008",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer $\\frac{5}{12}$ van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 3,
          "gridCols": 4,
          "targetCount": 5,
          "mode": "shade_count",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk arceren — grotere noemer",
            "content": "Tel het totaal: 3 × 4 = 12 vakjes. De noemer (12) klopt met het totaal. De teller (5) zegt: arceer 5 vakjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_grote_noemer",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het rooster heeft 3 × 4 = 12 vakjes. $\\frac{5}{12}$ betekent: arceer 5 van de 12 vakjes. Welke 5 vakjes je kiest maakt niet uit.",
        "solutionSteps": [
          "Tel het totaal: 3 × 4 = 12 vakjes",
          "De teller is 5 → arceer 5 vakjes",
          "Het maakt niet uit welke 5 vakjes"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-BREUK-RASTER-FEM-001",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "fraction_equivalence_match",
      "question": "Verbind elk rooster-deel met zijn gelijkwaardige breuk.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "fractionEquivalenceMatch": {
          "pairs": [
            {
              "fraction": { "numerator": 2, "denominator": 4, "visualType": "bar" },
              "equivalent": "1/2"
            },
            {
              "fraction": { "numerator": 3, "denominator": 9, "visualType": "bar" },
              "equivalent": "1/3"
            },
            {
              "fraction": { "numerator": 4, "denominator": 8, "visualType": "bar" },
              "equivalent": "1/2"
            },
            {
              "fraction": { "numerator": 2, "denominator": 6, "visualType": "bar" },
              "equivalent": "1/3"
            }
          ]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Roosters en gelijkwaardige breuken",
            "content": "Vereenvoudig elke breuk door teller én noemer door hetzelfde getal te delen. $\\frac{2}{4}$ ÷ 2 = $\\frac{1}{2}$. $\\frac{3}{9}$ ÷ 3 = $\\frac{1}{3}$. $\\frac{4}{8}$ ÷ 4 = $\\frac{1}{2}$. $\\frac{2}{6}$ ÷ 2 = $\\frac{1}{3}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_equivalence_match",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      },
      "feedback": {
        "explanationText": "Vereenvoudig elke rooster-breuk. $\\frac{2}{4}$ = $\\frac{1}{2}$ (÷2). $\\frac{4}{8}$ = $\\frac{1}{2}$ (÷4). $\\frac{3}{9}$ = $\\frac{1}{3}$ (÷3). $\\frac{2}{6}$ = $\\frac{1}{3}$ (÷2). Twee paren stellen dezelfde waarde voor met verschillende roosters.",
        "solutionSteps": [
          "$\\frac{2}{4}$ ÷ 2 = $\\frac{1}{2}$",
          "$\\frac{3}{9}$ ÷ 3 = $\\frac{1}{3}$",
          "$\\frac{4}{8}$ ÷ 4 = $\\frac{1}{2}$",
          "$\\frac{2}{6}$ ÷ 2 = $\\frac{1}{3}$"
        ]
      }
    },
    {
      "id": "GET-BREUK-RASTER-FSB-001",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "fraction_strip_builder",
      "question": "Bouw $\\frac{5}{8}$ op een strook: verdeel in 8 gelijke stukken en kleur er 5 in.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "fractionStripBuilder": {
          "targetDenominator": 8,
          "targetNumerator": 5,
          "mode": "both"
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 8,
            "label": "$\\frac{5}{8}$ — 5 van 8 stukken",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Strook bouwen",
            "content": "Verdeel de strook eerst in zoveel stukken als het getal onder de streep aangeeft (8). Kleur dan zoveel stukken als het getal boven de streep (5). 5 stukken gekleurd, 3 blank.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_strip_build",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      },
      "feedback": {
        "explanationText": "$\\frac{5}{8}$ → het getal onder de streep (8) betekent: verdeel in 8 gelijke stukken. Het getal boven de streep (5) betekent: kleur 5 van die 8 stukken in. Resultaat: een strook waar precies $\\frac{5}{8}$ gekleurd is.",
        "solutionSteps": [
          "Getal onder de streep is 8 → verdeel in 8 stukken",
          "Getal boven de streep is 5 → kleur 5 stukken",
          "$\\frac{5}{8}$ ✓"
        ]
      }
    }
  ]
}